import styled, { css } from 'styled-components'
import { textStyled } from 'Pages/landings/common/styles'
import { LandingNames } from 'Pages/landings/common/constants'
import { ModalComponent } from 'Pages/landings/common/components/Modal'

export const Modal = styled(ModalComponent)`
	font-family: 'SBSansText';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #373a44;
`
export const ModalTitle = styled.h3`
	${textStyled('SBSansText', '36px', 700, '48px', '373A44', '0px')};
	text-align: center;
	margin: 0px;
`
const href = css<{ page: string }>`
	cursor: pointer;
	font-style: normal;
	${({ page }) => {
		if (page.includes(LandingNames.RKO))
			return css`
				${textStyled('Open Sans', '14px', 400, '20px', '0000ff', '0px')};
				line-height: 1.3;
			`
		if (page.includes(LandingNames.VED))
			return css`
				${textStyled('Open Sans', '14px', 600, '40px', '21ba72', '0px')};
				font-family: 'SBSansDisplay', 'Open Sans';
				font-weight: bold;
			`
		if (page.includes(LandingNames.BUSSINES))
			return textStyled('SBSansInterface', '16px', 400, '20px', '337ab7', '0px')
		if (page.includes(LandingNames.CREDITS))
			return textStyled('SBSansInterface', '16px', 400, '20px', '337ab7', '0px')
		if (page.includes(LandingNames.SELF_EMPLOYED))
			return textStyled('SBSansInterface', '16px', 400, '24px', '21ba72', '0px')
		return ''
	}}
`
export const Agreement = styled.span<{ page?: string }>`
	${href}
`
export const Politics = styled.a<{ page?: string }>`
	${href}
	text-decoration: none;
`
export const Title = styled.p<{ page?: string }>`
	font-style: normal;
	${({ page }) => {
		if (page.includes(LandingNames.RKO)) {
			return css`
				${textStyled('Open Sans', '14px', 400, '20px', '6b6a6a', '0px')};
				line-height: 1.3;
				padding-top: 32px;
				max-width: 280px;
			`
		}
		if (page.includes(LandingNames.VED))
			return css`
				${textStyled('Open Sans', '14px', 600, '40px', '2D3045', '0px')};
				font-weight: bold;
				margin-left: 8px;
				font-family: 'SBSansDisplay', 'Open Sans';
			`
		if (page.includes(LandingNames.BUSSINES))
			return css`
				${textStyled('SBSansInterface', '16px', 400, '20px', '2D3045', '0px')}
				margin-bottom: 16px;
			`
		if (page.includes(LandingNames.CREDITS))
			return css`
				${textStyled('SBSansInterface', '16px', 400, '20px', '2D3045', '0px')}
				margin-bottom: 16px;
			`
		if (page.includes(LandingNames.SELF_EMPLOYED))
			return css`
				${textStyled('SBSansInterface', '16px', 400, '24px', '2D3045', '0px')};
				margin-left: 8px;
			`
		return ''
	}}
	@media (min-width: 768px) {
		flex-direction: row;
	} ;
`
